__turbopack_context__.v({
  "banner": "styles-module__DAd8Fa__banner",
  "body": "styles-module__DAd8Fa__body",
  "closeButton": "styles-module__DAd8Fa__closeButton",
  "ctaLink": "styles-module__DAd8Fa__ctaLink",
  "inner": "styles-module__DAd8Fa__inner",
  "main": "styles-module__DAd8Fa__main",
  "separator": "styles-module__DAd8Fa__separator",
  "text": "styles-module__DAd8Fa__text",
  "title": "styles-module__DAd8Fa__title",
});
